export default __webpack_public_path__ + "static/media/480_business03-es-mobile.257bba86.png";